import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  withStyles,
} from '@material-ui/core';

import TextField from '@material-ui/core/TextField';
import Question from '../question/Question';

const Phonecard = ({ daten, cardcontent, handleUpdate, url }) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;

  const handleChange = phonenumber => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    'phonenumber' in daten['info'][cardID]
      ? 0
      : (daten['info'][cardID]['phonenumber'] = {}); //Create Dict in Info if not exists

    daten['info'][cardID]['phonenumber'] = phonenumber;
    handleUpdate(daten);
  };

  let renderObjekt = (
    <TextField
      InputProps={{
        style: {
          width: '190px',
        },
      }}
      id="telefon"
      label="Ihre Telefonnummer"
      type="tel"
      value={
        daten['info'][cardID]['phonenumber']
          ? daten['info'][cardID]['phonenumber']
          : ''
      }
      onChange={e => {
        const phonenumber = e.target.value;
        handleChange(phonenumber);
      }}
    ></TextField>
  );

  return (
    <div className="h-full flex flex-col justify-between" id="phonecard">
      <div className="text-center mt-40px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div>
        <div className="text-center">{renderObjekt}</div>
      </div>

      <div className="h-40px"></div>
    </div>
  );
};

export default Phonecard;
